// PatientRoutes.js
import React from "react";
import { Outlet } from "react-router-dom";
import AuthGuard from "./AuthGuard";
import Header from "../components/header";
import FooterV2 from "../components/FooterV2";
import { Roles } from "../constants";
import AppInitializer from "../components/AppInitializer";

function PatientRoutes() {
  return (
    <AppInitializer>
      <AuthGuard role={Roles.PATIENT}>
        <Header />
        <Outlet />
        <FooterV2 />
      </AuthGuard>
    </AppInitializer>
  );
}

export default PatientRoutes;
